import moment from 'moment';
import { storeTranslations } from '../redux/actions/globalizationAction';
import globalizationService from '../services/globalizationService';
import store from '../redux/store';
import { GLOBALIZATION_SYSTEM_ID } from '../constants/globalizationConstants';

// Requisição das traduções no idioma atualmente selecionado
// se tiver e o tempo do cache do cache não tiver acabado
// não deve ser feita uma nova requisição
const getDataTermAndTranslationsByTag = async (culture, translationsCache, lastCacheTime) => {
  const currentUserLanguage = localStorage.getItem('userLanguage');
  const timeNow = new Date().getTime();
  const cacheTimeNow = moment(timeNow).format('YYYY-MM-DD hh:mm:ss');
  const lastCacheTimeSaved = lastCacheTime ? moment(lastCacheTime).format('YYYY-MM-DD hh:mm:ss') : null;
  const expiresCacheTime = lastCacheTime ? moment(lastCacheTime).add(1, 'hours').format('YYYY-MM-DD hh:mm:ss') : null;

  const params = {
    systemId: GLOBALIZATION_SYSTEM_ID,
    tag: 'Global',
    culture: culture || currentUserLanguage,
  };

  // Verifica os dados em cache para fazer ou não a requisição da tradução no idioma atual
  // Se já houver no cache traduções do idioma selecionado, não é feita nova requisição
  // Mas se feita após 1 hora desde o último cache salvo, é feita outra requisição
  if (
    translationsCache === []
    || translationsCache === null
    || !translationsCache[culture]
    || lastCacheTimeSaved === null
    || expiresCacheTime <= cacheTimeNow
  ) {
    const responseJSON = await globalizationService().getTermAndTranslationsByTag(params);
    const translationsList = responseJSON ? responseJSON.response : null;

    const newTranslationsCache = {
      ...translationsCache,
      [culture || currentUserLanguage]: translationsList,
    };

    // Atualiza objeto de traduções na store (cache)
    store.dispatch(storeTranslations(newTranslationsCache, cacheTimeNow));
  }

  return translationsCache;
};

export default getDataTermAndTranslationsByTag;
